import React, {useState, useEffect, createContext} from 'react';
import axios from "./axios";

const ShortcutContext = createContext([{}, () => {}]);

const ShortcutProvider = (props) => {
    const {children} = props;

    const [globalShortcuts, setGlobalShortcuts] = useState([]);
    const [contextualShortcuts, setContextualShortcuts] = useState([]);
    const [activityShortcuts, setActivityShortcuts] = useState([]);
    const [dashboardShortcuts, setDashboardShortcuts] = useState([]);
    const [shortcutMap, setShortcutMap] = useState(new Map());
    const [shortcutIdMap, setShortcutIdMap] = useState(new Map());

    const findShortcutByUrl = (url) => {
        const shortcut = shortcutMap.get(shortcutUrl);
        return shortcut;
    }

    const loadShortcuts = () => {
        axios.get('/web/ui/nav/shortcuts')
            .then(response => {
                setGlobalShortcuts(response.data.globalShortcuts);
                setContextualShortcuts(response.data.contextualShortcuts);
                setActivityShortcuts(response.data.activityShortcuts);
                setDashboardShortcuts(response.data.dashboardShortcuts);

                const updatedShortcutMap = new Map();
                const updatedShortcutIdMap = new Map();
                response.data.globalShortcuts.map((shortcut) => {
                    updatedShortcutMap.set(shortcut.url, shortcut);
                    updatedShortcutIdMap.set(shortcut.shortcutId, shortcut);
                    shortcut.childShortcuts.map((childShortcut) => {
                        updatedShortcutMap.set(childShortcut.url, childShortcut);
                        updatedShortcutIdMap.set(childShortcut.shortcutId, childShortcut);
                    });
                });
                response.data.contextualShortcuts.map((shortcut) => {
                    updatedShortcutMap.set(shortcut.url, shortcut);
                    updatedShortcutIdMap.set(shortcut.shortcutId, shortcut);
                });
                response.data.activityShortcuts.map((shortcut) => {
                    updatedShortcutMap.set(shortcut.url, shortcut);
                    updatedShortcutIdMap.set(shortcut.shortcutId, shortcut);
                });
                response.data.linkShortcuts.map((shortcut) => {
                    updatedShortcutMap.set(shortcut.url, shortcut);
                    updatedShortcutIdMap.set(shortcut.shortcutId, shortcut);
                });
                setShortcutMap(updatedShortcutMap);
                setShortcutIdMap(updatedShortcutIdMap);
            });
    }

    useEffect(() => {
        loadShortcuts();
    }, []);



    const contextValue =  {
        globalShortcuts,
        contextualShortcuts,
        activityShortcuts,
        dashboardShortcuts,
        shortcutMap,
        shortcutIdMap,
        findShortcutByUrl
    }

    return (
        <ShortcutContext.Provider value={contextValue}>
            {children}
        </ShortcutContext.Provider>
    );
}

export {ShortcutContext, ShortcutProvider};